function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import classNames from "classnames";
import { injectIntl } from "react-intl";
import Icon from "./Icon";
var AppMenuSearchBox = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(AppMenuSearchBox, PureComponent);
    var _super = _createSuper(AppMenuSearchBox);
    function AppMenuSearchBox(props) {
        _classCallCheck(this, AppMenuSearchBox);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            query: props.query || ""
        };
        return _this;
    }
    var _proto = AppMenuSearchBox.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.query !== this.props.query) {
            this.setState({
                query: this.props.query
            });
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, doSearch = _this_props.doSearch, toggleFavOnly = _this_props.toggleFavOnly, favOnly = _this_props.favOnly, clearSearch = _this_props.clearSearch, intl = _this_props.intl, isSearching = _this_props.isSearching, hasResults = _this_props.hasResults, isLoading = _this_props.isLoading;
        var query = this.state.query;
        var sClasses = classNames("app-menu__search-btn", {
            "pp-menu__search-btn--searching": isSearching
        });
        var favOnlyClasses = classNames("app-menu__favorites-only", {
            active: favOnly
        });
        return /*#__PURE__*/ React.createElement("div", {
            className: "app-menu__search-wrapper",
            role: "search"
        }, /*#__PURE__*/ React.createElement("form", {
            className: "app-menu__search-form",
            onSubmit: function(event) {
                event.preventDefault();
                doSearch(query);
            }
        }, /*#__PURE__*/ React.createElement("label", {
            htmlFor: "searchInput",
            className: "sr-only"
        }, intl.formatMessage({
            id: "menu.search_label",
            defaultMessage: "Search for slides, notes and communities"
        })), /*#__PURE__*/ React.createElement("input", {
            type: "search",
            value: query,
            placeholder: intl.formatMessage({
                id: "menu.search_input",
                defaultMessage: "Search"
            }),
            className: "app-menu__search",
            id: "searchInput",
            onChange: function(event) {
                return _this.setState({
                    query: event.target.value
                });
            }
        }), hasResults && /*#__PURE__*/ React.createElement("button", {
            className: "app-menu__search-close",
            onClick: function() {
                _this.setState({
                    query: ""
                });
                clearSearch();
            },
            type: "reset",
            "aria-label": intl.formatMessage({
                id: "menu.search_clear",
                defaultMessage: "Clear search"
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "close-line",
            size: "s"
        })), !hasResults && /*#__PURE__*/ React.createElement("button", {
            disabled: isSearching || isLoading,
            className: sClasses,
            type: "submit",
            "data-testid": "submit-button",
            "aria-label": intl.formatMessage({
                id: "menu.search_label",
                defaultMessage: "Search"
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "search",
            size: "s"
        }))), !query && !hasResults ? /*#__PURE__*/ React.createElement("div", {
            className: favOnlyClasses
        }, /*#__PURE__*/ React.createElement("input", {
            type: "checkbox",
            id: "show-only-favorites",
            checked: favOnly,
            onChange: function() {
                return toggleFavOnly(!favOnly);
            }
        }), /*#__PURE__*/ React.createElement("label", {
            htmlFor: "show-only-favorites"
        }, intl.formatMessage({
            id: "menu.show_fav",
            defaultMessage: "Show favourites only"
        }), /*#__PURE__*/ React.createElement(Icon, {
            name: favOnly ? "star-fill" : "star-outline",
            size: "s"
        }))) : null);
    };
    return AppMenuSearchBox;
}(PureComponent);
export default injectIntl(AppMenuSearchBox);
